<template>
  <div class="table-pilar">
    <component-loading :value="loading" v-if="loading" />

    <template v-else>
      <div class="table-wrapper">
        <table class="tabela-pilar">
          <thead>
            <tr>
              <th class="col-ibge" @click="ordenar('id')" style="cursor:pointer">
                Cód. IBGE <v-icon small>mdi-swap-vertical</v-icon>
              </th>
              <th class="col-municipio" @click="ordenar('nome')" style="cursor:pointer">
                Município <v-icon small>mdi-swap-vertical</v-icon>
              </th>
              <th class="col-uf" @click="ordenar('sigla')" style="cursor:pointer">
                UF <v-icon small>mdi-swap-vertical</v-icon>
              </th>
              <th
                v-for="pilar in pilares"
                :key="pilar.key"
                class="col-pilar text-center"
              >
                <div class="d-flex align-center justify-center">
                  <span :style="{ color: pilar.cor }" class="font-weight-bold">{{ pilar.label }}</span>
                  <v-menu open-on-hover bottom offset-y>
                    <template #activator="{ on }">
                      <v-icon small class="ml-1" v-on="on" style="color: #9e9e9e; cursor: help;">mdi-information-outline</v-icon>
                    </template>
                    <div class="texto-pilar-popup" style="max-width:280px; background:#212121; color:#fff; padding:8px 12px; font-size:13px;">
                      <span>{{ textos[pilar.key] || pilar.label }}</span>
                      <span v-if="isAdminBrasil" class="d-block mt-1">
                        <a @click="abrirEdicaoTexto(pilar.key)" style="color:#90caf9; cursor:pointer;">Editar texto</a>
                      </span>
                    </div>
                  </v-menu>
                </div>
                <div class="text-caption" style="color: #757575;">{{ contagem[pilar.key] }} municípios</div>
              </th>
              <th class="col-acao"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="municipiosFiltrados.length === 0">
              <td colspan="8" class="text-center py-4" style="color: #757575;">Nenhum município encontrado.</td>
            </tr>
            <tr
              v-for="municipio in municipiosFiltrados"
              :key="municipio.id"
              @mouseover="hoverIndex = municipio.id"
              @mouseleave="hoverIndex = null"
            >
              <td class="col-ibge">{{ municipio.id }}</td>
              <td class="col-municipio">{{ municipio.nome }}</td>
              <td class="col-uf">{{ municipio.sigla }}</td>
              <td v-for="pilar in pilares" :key="pilar.key" class="col-pilar text-center">
                <v-checkbox
                  :input-value="municipio[pilar.key]"
                  :disabled="!podeEditar"
                  dense
                  hide-details
                  class="ma-0 pa-0 d-inline-flex"
                  color="primary1"
                  @change="(val) => alterarPilar(municipio, pilar.key, val)"
                />
              </td>
              <td class="col-acao">
                <button
                  v-if="isAdminBrasil"
                  class="btn-olho"
                  @click="abrirInfoComplementar(municipio)"
                  title="Ver detalhes"
                >
                  <v-icon size="20" color="#00995d">mdi-eye-outline</v-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-2 pl-1" style="font-size: 13px; font-weight: bold;">
        Total de Municípios: {{ municipiosUnicos }}
      </div>
    </template>

    <!-- Modal edição de texto explicativo -->
    <v-dialog v-model="dialogTexto" max-width="700">
      <v-card>
        <v-card-title class="primary1--text font-weight-bold">Texto Explicativo — {{ labelPilarEdicao }}</v-card-title>
        <v-card-text>
          <v-textarea v-model="textoEdicao" outlined rows="6" label="Descrição" class="texto-explicativo-textarea" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <button-cadu text="CANCELAR" outline @click="dialogTexto = false" />
          <button-cadu text="SALVAR" @click="salvarTextoExplicativo" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    municipios: { type: Array, default: () => [] },
    textos: { type: Object, default: () => ({}) },
    podeEditar: { type: Boolean, default: false },
    isAdminBrasil: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  data() {
    return {
      ordemCampo: 'nome',
      ordemAsc: true,
      hoverIndex: null,
      dialogTexto: false,
      pilarEdicao: '',
      textoEdicao: '',
      pilares: [
        { key: 'estatutaria', label: 'Estatutária', cor: '#00995d' },
        { key: 'comercial', label: 'Comercial', cor: '#00995d' },
        { key: 'cooperativismo', label: 'Cooperativismo', cor: '#00995d' },
        { key: 'credenciamento', label: 'Credenciamento', cor: '#00995d' }
      ]
    }
  },
  computed: {
    municipiosFiltrados() {
      return [...this.municipios].sort((a, b) => {
        const va = a[this.ordemCampo]
        const vb = b[this.ordemCampo]
        if (va < vb) return this.ordemAsc ? -1 : 1
        if (va > vb) return this.ordemAsc ? 1 : -1
        return 0
      })
    },
    contagem() {
      return {
        estatutaria: this.municipios.filter((m) => m.estatutaria).length,
        comercial: this.municipios.filter((m) => m.comercial).length,
        cooperativismo: this.municipios.filter((m) => m.cooperativismo).length,
        credenciamento: this.municipios.filter((m) => m.credenciamento).length
      }
    },
    municipiosUnicos() {
      return this.municipios.length
    },
    labelPilarEdicao() {
      return this.pilares.find((p) => p.key === this.pilarEdicao)?.label || this.pilarEdicao
    }
  },
  methods: {
    ordenar(campo) {
      if (this.ordemCampo === campo) {
        this.ordemAsc = !this.ordemAsc
      } else {
        this.ordemCampo = campo
        this.ordemAsc = true
      }
    },
    alterarPilar(municipio, pilar, valor) {
      this.$emit('alterarPilar', { municipio, pilar, valor })
    },
    abrirInfoComplementar(municipio) {
      this.$emit('abrirInfoComplementar', municipio)
    },
    abrirEdicaoTexto(pilar) {
      this.pilarEdicao = pilar
      this.textoEdicao = this.textos[pilar] || ''
      this.dialogTexto = true
    },
    salvarTextoExplicativo() {
      this.$emit('salvarTexto', { pilar: this.pilarEdicao, descricao: this.textoEdicao })
      this.dialogTexto = false
    }
  }
}
</script>

<style lang="scss" scoped>
.table-pilar {
  padding: 0 8px;
}

.table-wrapper {
  overflow-x: auto;
}

.tabela-pilar {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  th, td {
    padding: 10px 8px;
    border-bottom: 1px solid #e0e0e0;
    text-align: left;
    vertical-align: middle;
    white-space: nowrap;
  }

  th {
    color: #60656c;
    user-select: none;
  }

  tr:hover td {
    background: #f5f5f5;
  }

  .col-ibge   { width: 120px; }
  .col-municipio { width: 220px; white-space: normal; }
  .col-uf     { width: 60px; }
  .col-pilar  { width: 120px; }
  .col-acao   { width: 50px; text-align: center; }
}

.texto-explicativo-textarea ::v-deep .v-input__control {
  height: auto !important;
  width: 100% !important;
}
.texto-explicativo-textarea ::v-deep .v-input__slot {
  min-height: 140px !important;
  width: 100% !important;
  padding: 8px 12px !important;
  align-items: flex-start;
}
.texto-explicativo-textarea ::v-deep textarea {
  min-height: 120px !important;
  padding-top: 8px;
  line-height: 1.5;
}

.btn-olho {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1.5px solid #00995d;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: #e8f5ee;
  }
}
</style>
